import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class StockTransferSelectAccountSliderModelService {
  public sotSelectAccountSlider: BehaviorSubject<boolean>;
  public sotSelectAccountSidenav: MatSidenav;
  private activeSliderValue: string;
  sotSelectAccountCloseRqt: Subject<boolean>;
  sotSelectAccountAddModelData: BehaviorSubject<any>;
  public shipToOrDeliverToAccount: number;
  public shipToAccount: number;
  public isCustomerPickup: boolean;
  public newItems: any;

  constructor() {
    this.sotSelectAccountSlider = new BehaviorSubject(false);
    this.sotSelectAccountAddModelData = new BehaviorSubject(EMPTY);
    this.sotSelectAccountCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;
    if (value === 'SOTSelectAccountSlider') {
      this.sotSelectAccountSlider.next(true);
      this.sotSelectAccountAddModelData.next(EMPTY);
      this.sotSelectAccountSidenav.toggle();
    }
  }

  public setStockTransferSideNav(sideNavObj: MatSidenav) {
    this.sotSelectAccountSidenav = sideNavObj;
  }

  public stockTransferClose() {
    this.sotSelectAccountAddModelData.next(EMPTY);
    this.sotSelectAccountSlider.next(false);
    this.sotSelectAccountSidenav.close();
  }

  public setData<T>(obj: T) {
    this.sotSelectAccountAddModelData.next(obj);
  }

  public getNewItem() {
    return this.newItems;
  }

  public setNewItem(newItems) {
    this.newItems = [];
    this.newItems = newItems;
  }
}
